import { INavLinkGroup, Nav } from "@m365-admin/nav";
import { useLocation, useNavigate } from "react-router-dom";
import { buildDisabledFeatureLookup } from "../Utils/js-common";
import { useGetUIEnablementsSettingsQuery } from "../slices/Home.slice";

export default function AdminNav(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const { data } = useGetUIEnablementsSettingsQuery(undefined);
  const decideColor = (paths: string[]) => ({
    selected: paths.includes(location.pathname),
    color: paths.includes(location.pathname) ? "lightcyan" : ""
  });

  const navLinkGroups: INavLinkGroup[] = [
    {
      key: "HomeGroup",
      links: [
        {
          name: "Home",
          icon: "Home",
          key: "HomeLink1",
          ariaLabel: "home",

          isSelected: decideColor(["/"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/"]).color
          },

          "data-id": "automation_id_22230",
          onClick: () => navigate("/")
        },
        {
          name: "Explore Customers",
          icon: "SecurityGroup",
          key: "Customer360",

          ariaLabel: "Explore Customers",
          isSelected: decideColor(["/customersearch", "/customer"]).selected,
          //  "data-id": "automation_id_22230",
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/customersearch", "/customer"]).color
          },
          onClick: () => navigate("/customersearch")
        },
        {
          name: "Explore Products",
          icon: "ProductVariant",
          key: "Product360",
          ariaLabel: "Explore Products",
          isSelected: decideColor(["/productview"]).selected,
          "data-id": "automation_id_22230",
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/products"]).color
          },
          onClick: () => navigate("/products")
        },
        {
          name: "Explore Reports",
          icon: "CRMReport",
          key: "ReportCatalog",
          ariaLabel: "Explore Reports",
          isSelected: decideColor(["/explorereports"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/explorereports"]).color
          },
          onClick: () => navigate("/explorereports")
        },
        {
          name: "Explore Partners",
          icon: "RecruitmentManagement",
          key: "ExplorePartners",
          ariaLabel: "Explore Partners",
          id: "ExplorePartners",
          isSelected: decideColor(["/partnersearch"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/partnersearch"]).color
          },
          onClick: () => navigate("/partnersearch")
        },
        {
          name: "AI Hub",
          icon: "Game",
          key: "AIHub",
          ariaLabel: "AI Hub",
          id: "AIHub",
          isSelected: decideColor(["/aihub"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/aihub"]).color
          },
          onClick: () => navigate("/aihub")
        },
        {
          name: "Explore Support Catalog",
          icon: "PublishCourse",
          key: "ExploreSupportCatalog",
          ariaLabel: "Explore Support Catalog",
          id: "ExploreSupportCatalog",
          isSelected: decideColor(["/explorereports?tab=supportCatalog"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/explorereports?tab=supportCatalog"]).color
          },
          onClick: () => navigate("/explorereports?tab=supportCatalog")
        },
        {
          name: "Explore Health",
          icon: "Health",
          key: "ExploreHealth",
          ariaLabel: "Explore Health",
          id: "ExploreHealth",
          isSelected: decideColor(["/explorehealth"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/explorehealth"]).color
          },
          onClick: () => navigate("/explorehealth")
        },
        {
          name: "Close the Loop",
          icon: "Sync",
          key: "CloseTheLoop",
          ariaLabel: "Close the Loop",
          id: "CloseTheLoop",
          isSelected: decideColor(["/closetheloop"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/closetheloop"]).color
          },
          onClick: () => navigate("/closetheloop")
        },
        {
          name: "CVC Customers",
          icon: "People",
          key: "CVCCustomer",
          ariaLabel: "CVC Customers",
          id: "CVCCustomer",
          isSelected: decideColor(["/cvccustomers"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/cvccustomers"]).color
          },
          onClick: () => navigate("/cvccustomers")
        },
        {
          name: "Purview CVC",
          icon: "Shield",
          key: "PurviewCVC",
          ariaLabel: "Purview CVC",
          id: "PurviewCVC",
          isSelected: decideColor(["/purviewcvc"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/purviewcvc"]).color
          },
          onClick: () => navigate("/purviewcvc")
        },
        // {
        //   name: "Product Scorecard",
        //   icon: "AnalyticsView",
        //   key: "ProductScorecard",
        //   ariaLabel: "Product Scorecard",
        //   isSelected: decideColor(["/productscorecard"]).selected,
        //   "data-id": "automation_id_22230",
        //   styles: {
        //     icon: {
        //       width: 15,
        //       height: 15,
        //       fontSize: 13
        //     },
        //     root: {
        //       "&:hover": {
        //         backgroundColor: "#F2F2F2"
        //       }
        //     }
        //   },
        //   style: {
        //     fontSize: 13,
        //     fontWeight: 400,
        //     backgroundColor: decideColor(["/productscorecard"]).color
        //   },
        //   onClick: () => navigate("/productscorecard")
        // },
        {
          name: "My Favorites",
          icon: "Favoritelist",
          key: "MyFavorites",
          ariaLabel: "MyFavorites ",
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          isSelected: decideColor(["/myfavorites"]).selected,
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/myfavorites"]).color
          },

          onClick: () => navigate("/myfavorites")
        },
        {
          name: "Data Research",
          icon: "ExploreData",
          key: "DataResearch",
          ariaLabel: "DataResearch",
          id: "DataResearch",
          isSelected: decideColor(["/dataresearch"]).selected,
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/dataresearch"]).color
          },
          onClick: () => navigate("/dataresearch")
        },
        {
          name: "Raise a Request",
          icon: "FeedbackRequestSolid",
          key: "RaiseRequest",
          ariaLabel: "Raise a Request",
          styles: {
            icon: {
              width: 15,
              height: 15,
              fontSize: 13
            },
            root: {
              "&:hover": {
                backgroundColor: "#F2F2F2"
              }
            }
          },
          isSelected: decideColor(["/Raiserequest"]).selected,
          style: {
            fontSize: 13,
            fontWeight: 400,
            backgroundColor: decideColor(["/Raiserequest"]).color
          },
          onClick: () => window.open("https://aka.ms/askcxeds", "_blank")
        }
      ]
    }
  ];

  const disabled = buildDisabledFeatureLookup(data || []);
  const disabledFeatures = disabled["feature"] || [];

  const filteredGroups = navLinkGroups.map((group) => ({
    ...group,
    links: group.links.filter(({ name }) => !disabledFeatures.map((item) => item.feature).includes(name as string))
  }));

  return (
    <div>
      {props.isNavCollapsed && (
        <Nav
          groups={filteredGroups}
          onNavCollapsed={() => {
            return props.onNavCollapsed;
          }}
          defaultIsNavCollapsed={props.isNavCollapsed}
          isNavCollapsed={props.onNavCollapsed}
          enableCustomization={false}
          collapseNavLinkProps={{
            "data-hint": "collapse test",
            title: props.isNavCollapsed ? "Expand Navigation" : "Collapse Navigation",
            primaryIconName: "GlobalNavButton",
            "aria-label": props.isNavCollapsed ? "Expand Navigation" : "Collapse Navigation"
          }}
          styles={{
            root: {
              position: "fixed",
              top: "48px",
              borderRight: "solid 1px #e1dfdd",
              //  Height: "calc(91.4vw - 100%)",
              height: "calc(100% - 48px)"
            },
            navContainer: {
              backgroundColor: "white",
              borderRight: "solid 1px #e1dfdd"
            }
          }}
          hideCollapseLink
          showMore={false}
        />
      )}
      {!props.isNavCollapsed && (
        <Nav
          groups={filteredGroups}
          onNavCollapsed={() => {
            return props.onNavCollapsed;
          }}
          collapseNavLinkProps={{
            "data-hint": "collapse test",
            title: props.isNavCollapsed ? "Expand Navigation" : "Collapse Navigation",
            primaryIconName: "GlobalNavButton",
            "aria-label": props.isNavCollapsed ? "Expand Navigation" : "Collapse Navigation"
          }}
          styles={{
            root: {
              position: "fixed",
              top: "48px",
              borderRight: "solid 1px #e1dfdd",
              //    Height: "calc(91.4vw - 100%)",
              height: "calc(100% - 48px)"
            },
            navContainer: {
              backgroundColor: "white",
              borderRight: "solid 1px #e1dfdd",
              maxWidth: "240px"
            }
          }}
          defaultIsNavCollapsed={props.isNavCollapsed}
          isNavCollapsed={props.onNavCollapsed}
          hideCollapseLink
          showMore={false}
          enableCustomization={false}
        />
      )}
    </div>
  );
}
